import axios from "axios";
import React, { Component } from "react";

import { Button, Divider, Select, Spin, Table, message } from "antd";
import { connect } from "react-redux";

import moment from "moment";
import AddMedicineModal from "../AllMedicines/AddMedicineModal";
import AddNonRxMedicineModal from "./AddNonRxMedicineModel";
import ShowAddedNonRxMedicineList from "./ShowAddedNonRxMedicineList";

import { ADD_NONRXMEDICINE_TO_LIST } from "../../ActionTypes/ActionTypes";

const { Column } = Table;
const { Option } = Select;

let timeout;
let currentValue;
// let currentValue1;

function fetch(value, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;

  function fake() {
    axios({
      method: "get",
      url: `/medicines/lookup_medicines?name=${value}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((d) => {
      let matchedList;
      if (currentValue === value) {
        matchedList = d.data;
      }
      // console.log(matchedList);
      callback(matchedList);
    });
  }

  timeout = setTimeout(fake, 700);
}

class AddNonRxLadingPage extends Component {
  state = {
    fetching: false,
    visibleTab: false,
    visibleMed: false,
    visibleTabSalt: "",
    result: [],
    dummy: [],
    matchedSaltList: [],
    data: [],
    docData: [],
    editMedModal: false,
    selectedValue: "",
    copiedSelectedValue: "",
    doseInfo: "",
    dosageDirection: "",
    doseFrequency: "",
    medicineTenure: "",
    confirmLoading: false,
    dataForModal: {},
    dataForEdit: {},
    resultz: [],
    selectedDoc: "",

    medTableLoading: false,
  };

  componentDidMount = () => {
    const { order_id, history } = this.props;

    if (order_id === "") {
      history.push("/allOrders");
    }
  };

  showTabModal = (value) => {
    this.setState({
      copiedSelectedValue: value,
      visibleTab: true,
    });
  };

  handleTabCancel = () => {
    this.setState({ visibleTab: false });
  };

  showMedModal = () => {
    this.setState({ visibleMed: true });
  };

  handleMedCancel = () => {
    this.setState({ visibleMed: false });
  };

  showTabSaltModal = (value) => {
    const id = value.split("#")[0];
    this.setState({
      copiedSelectedValue: value,
      visibleTabSalt: id,
    });
  };

  handleTabSaltCancel = () => {
    this.setState({ visibleTabSalt: false });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  handleMedCreate = () => {
    const { form } = this.formRef.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      axios({
        method: "post",
        url: "/medicines.json",
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
        data: {
          medicine: values,
        },
      }).then((response) => {
        this.handleMedSelect(response.data.id);
      });
      form.resetFields();
      this.setState({ visibleMed: false });
    });
  };

  handleSearch = (value) => {
    this.setState({ fetching: true });
    fetch(value, (result) =>
      this.setState({
        result,
        fetching: false,
        matchedSaltList: [],
      })
    );
  };

  handleChange = (value) => {
    this.setState({
      selectedValue: value,
      data: [],
      matchedSaltList: [],
    });
  };

  handleMedSelect = (value) => {
    console.log(value);
    axios({
      method: "get",
      url: `/medicines/${value}.json`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      this.setState({
        data: [response.data],
      });
    });
  };

  showEditMedModal = () => {
    this.setState({ editMedModal: true });
  };

  handleEditMedModalCancel = () => {
    this.setState({ editMedModal: false });
  };

  saveFormRefEdit = (formRef) => {
    this.formRefEdit = formRef;
  };

  handleCreateEditMed = () => {
    const { data } = this.state;
    const { form } = this.formRefEdit.props;
    form.validateFields((err, values) => {
      if (err) {
        console.log(err);
        return;
      }

      this.setState({ confirmLoading: true });
      axios({
        method: "put",
        url: `/medicines/${data[0].id}.json`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
        data: { medicine: values },
      }).then(() => {
        form.resetFields();
        this.handleEditMedModalCancel();
        window.location.reload();
        this.setState({ confirmLoading: false });
      });
    });
  };

  handleGenericSearch = (salt) => {
    axios({
      method: "get",
      url: `/medicines/lookup_generics?salt=${salt}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      this.setState({
        matchedSaltList: response.data,
      });
    });
  };

  saveFormAddNonRx = (formRef) => {
    this.formAddNonRx = formRef;
  };

  handleNonRxMedicine = () => {
    const { form } = this.formAddNonRx.props;
    const { e_prescription_id, addMedicineToMedicineList } = this.props;
    const { copiedSelectedValue } = this.state;

    form.validateFields((err, values) => {
      if (err) {
        console.log(err);
      } else {
        values.non_prescription_medicine_end_date = moment(
          values.non_prescription_medicine_start_date,
          "DD-MM-YYYY"
        )
          .add(values.duration - 1, "days")
          .format("YYYY-MM-DD");
        values.non_prescription_medicine_start_date = moment(
          values.non_prescription_medicine_start_date,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        delete values.duration;
        // eslint-disable-next-line prefer-destructuring
        values.non_prescription_medicine_form =
          copiedSelectedValue.split("#")[4];
        values.medicine_id = Number(copiedSelectedValue.split("#")[0]);
        values.e_prescription_id = e_prescription_id;

        console.log(values);

        this.setState({
          confirmLoading: true,
        });

        axios({
          method: "post",
          url: "/non_prescription_medicines.json",
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
          data: {
            non_prescription_medicine: values,
          },
        })
          .then((response) => {
            console.log(response.data);
            addMedicineToMedicineList(response.data);
            form.resetFields();
            this.setState(
              {
                confirmLoading: false,
                visibleTab: false,
                data: [],
                matchedSaltList: [],
              },
              () => message.success("Medicine added successfully")
            );
          })
          .catch((error) => {
            console.log(error);
            this.setState(
              {
                confirmLoading: false,
                visibleTab: true,
                data: [],
                matchedSaltList: [],
              },
              () => message.success("Something went wrong!")
            );
          });
      }
    });
  };

  render() {
    const {
      result,
      dummy,
      selectedValue,
      fetching,
      dataForModal,
      visibleMed,
      data,
      confirmLoading,
      editMedModal,
      visibleTab,
      dataForEdit,
      copiedSelectedValue,
      matchedSaltList,
    } = this.state;

    const { nonRxMedicineList } = this.props;

    console.log(nonRxMedicineList);

    const options =
      result === undefined
        ? dummy.map((d) => <Option key={d.id}>{d.name}</Option>)
        : result.map((d) => <Option key={d.id}>{d.name}</Option>);

    return (
      <div style={{ paddingTop: "1%", textAlign: "center" }}>
        <Select
          showSearch
          value={selectedValue}
          placeholder="Start typing medicine name ..."
          style={{ width: "40%" }}
          defaultActiveFirstOption={false}
          showArrow={false}
          filterOption={false}
          onSearch={this.handleSearch}
          onChange={this.handleChange}
          onSelect={this.handleMedSelect}
          notFoundContent={fetching ? <Spin size="small" /> : null}
        >
          {options}
        </Select>

        <br />

        <p style={{ fontWeight: "bold" }}>or</p>

        <div style={{ paddingTop: "5px" }}>
          <Button type="primary" onClick={this.showMedModal}>
            Add Medicine
          </Button>
          <AddMedicineModal
            wrappedComponentRef={this.saveFormRef}
            data={dataForModal}
            visible={visibleMed}
            onCancel={this.handleMedCancel}
            onCreate={this.handleMedCreate}
          />
        </div>

        <div style={{ width: "80%", paddingTop: "5%", margin: "auto" }}>
          {data.length !== 0 ? (
            <div style={{ paddingTop: "2%" }}>
              <h2 style={{ textAlign: "center" }}>Medicine</h2>
              <Table
                dataSource={data}
                pagination={false}
                size="large"
                rowKey="id"
              >
                <Column title="ID" dataIndex="id" align="center" />
                <Column title="Name" dataIndex="name" align="center" />
                <Column
                  title="Packaging Use"
                  dataIndex="packaging_use"
                  align="center"
                />
                <Column
                  title="Salt"
                  dataIndex="salt"
                  align="center"
                  width="250px"
                />
                <Column
                  title="Price"
                  dataIndex="price"
                  key="price"
                  align="center"
                />
                <Column
                  title="View Generic"
                  render={(text, record) => (
                    <span>
                      <Button
                        type="primary"
                        shape="circle"
                        icon="search"
                        onClick={() => this.handleGenericSearch(record.salt)}
                      />
                    </span>
                  )}
                  align="center"
                />
                <Column
                  title="Edit or Add in Order"
                  render={(text, record) => (
                    <span>
                      <span>
                        <Button
                          type="primary"
                          shape="circle"
                          icon="edit"
                          onClick={this.showEditMedModal}
                        />
                        <AddMedicineModal
                          wrappedComponentRef={this.saveFormRefEdit}
                          data={data[0]}
                          visible={editMedModal}
                          onCancel={this.handleEditMedModalCancel}
                          onCreate={this.handleCreateEditMed}
                          confirmLoading={confirmLoading}
                        />
                      </span>

                      <Divider type="vertical" />

                      <span>
                        <Button
                          type="primary"
                          onClick={() =>
                            this.showTabModal(
                              `${record.id}#${record.name}#${record.salt}#${record.price}#${record.form}`
                            )
                          }
                        >
                          Add in Order
                        </Button>
                        <AddNonRxMedicineModal
                          wrappedComponentRef={this.saveFormAddNonRx}
                          visible={visibleTab}
                          onCancel={this.handleTabCancel}
                          onCreate={this.handleNonRxMedicine}
                          data={dataForEdit}
                          confirmLoading={confirmLoading}
                          selectedMed={copiedSelectedValue}
                        />
                      </span>
                    </span>
                  )}
                  align="center"
                />
              </Table>
            </div>
          ) : null}

          {matchedSaltList.length > 1 ? (
            <div style={{ paddingTop: "2%" }}>
              <h2 style={{ textAlign: "center" }}>Generic options</h2>
              <Table dataSource={matchedSaltList} size="small" rowKey="id">
                <Column title="ID" dataIndex="id" align="center" />
                <Column title="Name" dataIndex="name" align="center" />
                <Column
                  title="Salt"
                  dataIndex="salt"
                  align="center"
                  width="250px"
                />
                <Column
                  title="View Generic"
                  render={() => (
                    <span>
                      <Button
                        type="primary"
                        shape="circle"
                        icon="search"
                        onClick={this.handleGenericSearch}
                      />
                    </span>
                  )}
                  align="center"
                />
                <Column
                  title="Add in Order"
                  render={(text, record) => (
                    <span>
                      <Button
                        type="primary"
                        onClick={() =>
                          this.showTabSaltModal(
                            `${record.id}#${record.name}#${record.salt}#${record.price}#${record.form}`
                          )
                        }
                      >
                        Add To Order
                      </Button>

                      {/* <MedInfoModal
                                                    visible={Number(visibleTabSalt) === Number(record.id)}
                                                    onCancel={this.handleTabSaltCancel}
                                                    data={dataForEdit}
                                                    selectedMed={copiedSelectedValue}
                                                    handleDoseInfo={this.handleDoseInfo}
                                                    handleDoseDirection={this.handleDoseDirection}
                                                    handleDoseFrequency={this.handleDoseFrequency}
                                                    handleMedicineTenure={this.handleMedicineTenure}
                                                /> */}
                    </span>
                  )}
                  align="center"
                />
              </Table>
            </div>
          ) : null}

          <ShowAddedNonRxMedicineList />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  order_id: state.AppState.order_id,
  nonRxMedicineList: state.AppState.nonRxMedicineList,
  end_date: state.AppState.end_date,
  e_prescription_id: state.AppState.ep_id,
});

const mapDispatchToProps = (dispatch) => ({
  addMedicineToMedicineList: (medicine) =>
    dispatch({ type: ADD_NONRXMEDICINE_TO_LIST, medicine }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddNonRxLadingPage);



// WEBPACK FOOTER //
// ./src/component/AddingNonRxMedicines/AddNonRxLadingPage.js